import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Stack } from '@mui/material';

import { getMediaThumbnailEditingEnabled } from '../../../redux/modules/auth';
import { VpButton, VpHoverInfo, VpConditionalUpgradeWrapper } from '..';

const CustomizeThumbnailButton = ({ customThumbnailEnabled = false, onClick = () => {} }) => {
  return (
    <VpConditionalUpgradeWrapper condition={!customThumbnailEnabled}>
      {({ isDisabled }) => (
        <Stack direction="row" alignItems="center" gap="5px" justifyContent="start">
          <VpButton onClick={onClick} disabled={isDisabled}>
            Customize Thumbnail
          </VpButton>
          <VpHoverInfo
            icon={isDisabled ? 'Lock' : 'HelpCircle'}
            iconProps={{ size: '16px', color: 'vpColors.grey' }}
            label={
              isDisabled
                ? ''
                : 'Changing the thumbnail will modify how your videos appear on the Plugins you have set up'
            }
          />
        </Stack>
      )}
    </VpConditionalUpgradeWrapper>
  );
};

CustomizeThumbnailButton.propTypes = {
  customThumbnailEnabled: PropTypes.bool,
  onClick: PropTypes.func
};

const mapStateToProps = (state) => ({
  customThumbnailEnabled: getMediaThumbnailEditingEnabled(state)
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CustomizeThumbnailButton);



// WEBPACK FOOTER //
// ./src/vp-ui/components/CustomizeThumbnailButton/CustomizeThumbnailButton.jsx